export const TITLES = {
  0: 'Meetings notifications',
}
